// extracted by mini-css-extract-plugin
export default {"newPasswordInput":"styles_newPasswordInput__4XoXd","newPasswordLabel":"styles_newPasswordLabel__3OU9E","changePasswordBtn":"styles_changePasswordBtn__gJggL"};